import React from 'react';
import { useSearchParams } from 'react-router-dom';

import CustomTabPanel from 'components/Shared/CustomTabPanel';
import CustomTabs from 'components/Shared/CustomTabs';
import RowsSkeleton from 'components/Shared/Skeleton/RowsSkeleton';
import NoteTab from '../../Note/Notetab';

import { useShipmentUnLoadingDetailContext } from 'contexts/ShipmentUnLoadingDetailContext';

import { useGetNotesBySourceQuery } from 'store/services/noteApi';
import { useGetDocumentsBySourceQuery } from "store/services/documentApi";
import DocumentsTab from "../../Document/DocumentTab";
import UnloadingShipmentList from "./UnloadingShipmentList";

const ShipmentUnLoadingDetailTab = () => {

  const [searchParams] = useSearchParams();

  const activeTab = searchParams.get('tab') || 'note';
  
  const { shipmentUnLoadingDetail } = useShipmentUnLoadingDetailContext();

  // Fetch notes to get the count for the badge
  const { data: notes } = useGetNotesBySourceQuery(
    { source: 'ShipmentUnLoading', sourceRef: shipmentUnLoadingDetail?._id, },{ skip: !shipmentUnLoadingDetail?._id } 
  );

   // Fetch documents to get the count for the badge
      const { data: documents } = useGetDocumentsBySourceQuery(
          { source: 'ShipmentUnLoading', sourceRef: shipmentUnLoadingDetail?._id, }, { skip: !shipmentUnLoadingDetail?._id }
      );

  const tabs = [
    {
      label: 'Note',
      value: 'note',
      badgeCount: notes?.length || 0, 
    },
    { label: "Document", value: "document", badgeCount: documents?.totalItems },

    { label: "Shipment", value: "shipment", badgeCount: shipmentUnLoadingDetail?.shipmentId?.length },
  ];

  return (
    <>
      <CustomTabs tabs={tabs} activeTab={activeTab} />

      {shipmentUnLoadingDetail ? (
        <>
        <CustomTabPanel activeTab={activeTab} value="note">
          <NoteTab source="ShipmentUnLoading" sourceRef={shipmentUnLoadingDetail._id} />
        </CustomTabPanel>
         <CustomTabPanel activeTab={activeTab} value="document">
         <DocumentsTab source="ShipmentUnLoading" sourceRef={shipmentUnLoadingDetail._id} />
     </CustomTabPanel>

     <CustomTabPanel activeTab={activeTab} value="shipment">
         <UnloadingShipmentList/>
     </CustomTabPanel>
 </>
      ) : (
        <RowsSkeleton />
      )}
    </>
  );
};

export default ShipmentUnLoadingDetailTab;